export default [{
  header: 'Aduanas',
  icon: 'PackageIcon',
  i18n: 'Apps',
  items: [
    {
      url: { name: 'dashboard' },
      name: 'Dashboard',
      icon: 'GridIcon',
      permiso: 'ED218'
    },
    {
      url: { name: 'batchs' },
      name: 'Lotes',
      icon: 'FileTextIcon',
      permiso: 'ED155'
    },
    {
      url: { name: 'batchs-review' },
      name: 'Lotes en revisión',
      icon: 'FileTextIcon',
      permiso: 'ED214'
    },
    {
      url: { name: 'auctions' },
      name: 'Subastas',
      icon: 'KeyIcon',
      permiso: 'ED156'
    },
    {
      url: { name: 'receipts' },
      name: 'Comprobantes',
      icon: 'FileTextIcon',
      permiso: 'ED157'
    },
    {
      url: { name: 'invoice-issued', params: { categoria: 'emitidos', vista: 'adjudicados' } },
      name: 'Documentos Tributarios',
      slug: 'files',
      icon: 'CreditCardIcon',
      permiso: 'ED164'
    }
  ]
}];
